import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import SnapfyAssistant from './SnapfyAssistant';

// Global floating helper mounted in Layout so the Snapfy Assistant is one click away
// on every authenticated page. Opens a compact chat panel anchored bottom-right.
const SnapfyAssistantLauncher: React.FC = () => {
  const { t } = useTranslation('assistant');
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* Chat panel */}
      <div
        className={`fixed bottom-40 right-4 sm:bottom-24 sm:right-6 z-50 w-[22rem] max-w-[calc(100vw-2rem)] h-[32rem] max-h-[calc(100vh-12rem)] bg-snapfy-surface border border-snapfy-border rounded-2xl shadow-modal flex flex-col overflow-hidden transition-all origin-bottom-right ${
          open ? 'opacity-100 scale-100 pointer-events-auto' : 'opacity-0 scale-95 pointer-events-none'
        }`}
        aria-hidden={!open}
      >
        <div className="flex items-center justify-between px-4 py-3 border-b border-snapfy-border">
          <div className="flex items-center gap-2">
            <svg className="w-4 h-4 text-[#9b8ff9]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
            </svg>
            <span className="font-bold text-snapfy-text-primary text-sm">{t('title')}</span>
          </div>
          <button
            onClick={() => setOpen(false)}
            className="text-snapfy-text-secondary hover:text-snapfy-text-primary"
            aria-label={t('close')}
          >
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="flex-1 min-h-0">
          {open && <SnapfyAssistant variant="panel" onNavigated={() => setOpen(false)} />}
        </div>
      </div>

      {/* Floating launcher button */}
      <button
        onClick={() => setOpen((v) => !v)}
        className="fixed bottom-24 right-4 sm:bottom-6 sm:right-6 z-40 w-14 h-14 rounded-full bg-snapfy-gradient text-white shadow-glow flex items-center justify-center hover:opacity-90 transition-opacity"
        aria-label={t('open')}
        title={t('open')}
      >
        {open ? (
          <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        ) : (
          <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-4 4v-4z" />
          </svg>
        )}
      </button>
    </>
  );
};

export default SnapfyAssistantLauncher;
